module.exports = __webpack_public_path__ + "static/media/guide-share-bg.e2646c59.png";